import React from 'react';

class CheckboxRenderer extends React.Component {

    constructor(props) {
        super(props);
        this.setValue = this.setValue.bind(this);
        this.state = {
            checkboxValue: 'false'
        };
    };

    render() {
        return (
            <form>
                {this.props.data !== undefined ?
                    <input type='checkbox' name="inputA1" onChange={this.setValue}
                        defaultChecked={this.props.data[this.props.colDef.field] === 'Y' || this.props.data[this.props.colDef.field] === true ? true : false}
                        disabled={typeof this.props.isDisabled === "boolean" ? this.props.isDisabled : false} />
                    : null}
            </form>
        );
    };


    setValue(val) {
        this.props.node.setDataValue(this.props.colDef.field, val.target.checked);
    }
}

export default CheckboxRenderer;